import SelectMeta from '@/common/components/Inputs/SelectMeta/SelectMeta';

export default SelectMeta;
